import Auth from "@aws-amplify/auth";

const useLoadSaleData = {
    methods: {
        async loadSaleData(force = false) {
            if (this.$store.state["sale"]["loading"] || force) {
                const user = await Auth.currentAuthenticatedUser();
                const u = {
                    id: user.attributes.sub,
                    // id: "5cc620d7-3570-4a9c-88db-b35f4b1d3396", // dev account
                    branch: user.attributes["custom:branch"],
                    firstname: user.attributes["custom:firstname"],
                    lastname: user.attributes["custom:lastname"],
                };
                this.$store.dispatch("sale/syncSale", u);
            }
        },
    },
};

export default useLoadSaleData;
